import { Popover, Tag, Spin } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import { useState } from 'react';
import httpInjectorService from 'services/http-injector.service';
import { ThunderboltOutlined } from '@ant-design/icons';
import SubtaskObject from '@atlaskit/object/subtask';
import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';
import UserAvatar from 'components/userAvatar';
import { toast } from 'react-toastify';
import { Tooltip } from "antd";

const LinkedItemsPopover = ({ item_id, item_type, details }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  

  const fetchLinkedItems = async () => {
  setLoading(true);
  try {
    let reqbody = { item_type, item_id };
    let response = await httpInjectorService.getLinkedWorkItems(reqbody);

    if (response.status === 'success') {
      setData(response.data);
    } else {
      setData({});
    }
  } catch (e) {
    console.error(e);
  }
  setLoading(false);
};

 const handleOpen = async (visible) => {
  setOpen(visible);

  if (visible) {
    fetchLinkedItems();   // 👈 use reusable function
  }
};

   const handleDelete = async (item) => {
    
      try {
        setLoading(true);
        let response = await httpInjectorService.deletelinkType(item.link_id);
        if (response.status === 'success') {
          toast.success(response.message, { autoClose: 3000 });
          fetchLinkedItems()
         
        } else {
          toast.error(response.message, { autoClose: 3000 });
        }
      } catch (err) {
        throw err;
      } finally {
        setLoading(false);
      }
    };

 

  const getIcon = (item) => {
    if (item.item_type === 'epic') {
      return <ThunderboltOutlined style={{ color: '#6554C0', fontSize: 16 }} />;
    }

    if (item.item_type === 'subtask') {
      return <SubtaskObject />;
    }

    if (item.issue_type_id === 1) {
      return <TaskObject />;
    }

    if (item.issue_type_id === 2) {
      return <StoryObject />;
    }

    if (item.issue_type_id === 3) {
      return <BugObject />;
    }

    return null;
  };

  const content = (
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: 320,
        maxHeight: 300,
        overflowY: 'auto',
      }}
    >
      
      {/* 🔷 MAIN ITEM (NO RED LINE HERE) */}
     
      {/* ❌ No linked data */}
      {!loading && data && Object.keys(data).length === 0 && (
        <div style={{ fontSize: 12, color: '#888' }}>No linked items</div>
      )}

      {/* 🔗 RELATIONS */}
      {data &&
        Object.entries(data).map(([relation, items]) => (
          <div key={relation} style={{ marginBottom: 12 }}>
            {/* 🔴 RELATION HEADER */}
             {!loading && details && (
        <div style={{ marginBottom: 12 }}>
          {/* <h4 style={{ fontSize: 13 }}></h4> */}

          <div style={itemStyle}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              {getIcon(details)}
              <b>{details.key ||details.epic_key}</b>
              <span>- {details.title|| details.name}</span>
            </div>

            <div
  style={{
    display: 'flex',
    justifyContent: 'space-between', // ✅ pushes icon to right
    alignItems: 'center',
  }}
>
  {/* LEFT SIDE */}
  <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
    <Tag>{details.task_status ||details.epic_status}</Tag>
    <UserAvatar
      username={details.assignee_name || details.epic_assignee||'Unassigned'}
      size={20}
    />
  </div>

  {/* RIGHT SIDE (LINK ICON) */}
 
</div>
          </div>
        </div>
      )}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {/* RED LINE */}
              <div
                style={{
                  width: 3,
                  height: 18,
                  background: '#ff4d4f',
                  borderRadius: 2,
                }}
              />

              {/* ICON + RELATION TEXT */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <LinkOutlined style={{ color: '#ff4d4f', fontSize: 12 }} />
                <span
                  style={{
                    fontSize: 13,
                    textTransform: 'capitalize',
                    color: '#333',
                  }}
                >
                  {relation}
                </span>
              </div>
            </div>

            {/* 🔽 ITEMS */}
            <div style={{ marginLeft: 12, marginTop: 6 }}>
              {items.map((item) => (
                <div key={item.link_id} style={itemStyle}>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 6 }}
                  >
                    {getIcon(item)}
                    <b>{item.key}</b>
                    <span>- {item.title}</span>
                  </div>

                 <div
  style={{
    display: 'flex',
    justifyContent: 'space-between', // ✅ pushes icon to right
    alignItems: 'center',
  }}
>
  {/* LEFT SIDE */}
  <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
    <Tag>{item.status}</Tag>
    <UserAvatar
      username={item.assignee || 'Unassigned'}
      size={20}
    />
  </div>

  {/* RIGHT SIDE (LINK ICON) */}
<Tooltip title="Unlink item">
  <LinkOutlined
    onClick={() => handleDelete(item)}   // ✅ correct
    style={{ cursor: 'pointer', color: '#ff4d4f' }}
  />
</Tooltip>
</div>
                </div>
              ))}
            </div>
          </div>
        ))}
    </div>
  );
  return (
    <Popover
      content={content}
      trigger="click"
      placement="bottomRight"
      open={open}
      onOpenChange={handleOpen}
    >
      <span
        onClick={(e) => e.stopPropagation()}
        style={{ display: 'inline-flex', cursor: 'pointer' }}
      >
        <LinkOutlined />
      </span>
    </Popover>
  );
};

const itemStyle = {
  padding: '6px',
  border: '1px solid #eee',
  borderRadius: '4px',
  marginBottom: '6px',
  background: '#fafafa',
};

export default LinkedItemsPopover;
